export const GET_GLOVO_ENABLED_PHARMACY_STATUS =
  'GET_GLOVO_ENABLED_PHARMACY_STATUS';
export const SET_ENABLE_GLOVO_PHARMACY = 'SET_ENABLE_GLOVO_PHARMACY';
export const SET_DISABLE_GLOVO_PHARMACY = 'SET_DISABLE_GLOVO_PHARMACY';
